module.exports = __webpack_public_path__ + "static/img/ct_qt_2.f33d9e43.png";